export const SET_PROMISED_PAYMENT_DATA = 'FINANCE/SET_PROMISED_PAYMENT_DATA'
export const FETCH_PROMISED_PAYMENT_SETTINGS = 'FINANCE/FETCH_PROMISED_PAYMENT_SETTINGS'
export const CREATE_PROMISED_PAYMENT_REQUEST = 'FINANCE/CREATE_PROMISED_PAYMENT_REQUEST'
export const FETCH_PROMISED_PAYMENT = 'FINANCE/FETCH_PROMISED_PAYMENT'
export const SET_PROMISED_PAYMENT_SETTINGS = 'FINANCE/SET_PROMISED_PAYMENT_SETTINGS'
export const RESET_PROMISED_PAYMENT_DATA = 'FINANCE/RESET_PROMISED_PAYMENT_DATA'
export const DROP_PROMISED_PAYMENT_DATA = 'FINANCE/DROP_PROMISED_PAYMENT_DATA'
export const SET_PROMISED_PAYMENT_FILTERS = 'FINANCE/SET_PROMISED_PAYMENT_FILTERS'
export const SET_TAKEN_PROMISED_PAYMENT_DATA = 'FINANCE/SET_TAKEN_PROMISED_PAYMENT_DATA'
export const FETCH_TAKEN_PROMISED_PAYMENT = 'FINANCE/FETCH_TAKEN_PROMISED_PAYMENT'
